
import { lazy } from "react";

export const saioRoutes = [
  {
    path: "/saio-dashboard",
    element: lazy(() => import("@/pages/SaioDashboardPage")),
    meta: {
      title: "SAIO Dashboard",
      description: "Search AI Optimization dashboard and analytics"
    }
  },
  {
    path: "/prompts",
    element: lazy(() => import("@/pages/PromptsPage")),
    meta: {
      title: "Prompts",
      description: "Manage and create AI prompts for analysis"
    }
  },
  {
    path: "/run-analysis",
    element: lazy(() => import("@/pages/RunAnalysisPage")),
    meta: {
      title: "Run Analysis",
      description: "Execute AI analysis on your prompts and keywords"
    }
  },
  {
    path: "/scheduler",
    element: lazy(() => import("@/pages/SchedulerPage")),
    meta: {
      title: "Scheduler",
      description: "Schedule and manage automated analysis tasks"
    }
  },
  {
    path: "/dynamic-people-classification",
    element: lazy(() => import("@/pages/DynamicPeopleClassificationPage")),
    meta: {
      title: "People Classification",
      description: "Analyze prompts to identify and classify people mentioned in content"
    }
  },
  {
    path: "/ai-search-optimization-framework",
    element: lazy(() => import("@/pages/AiSearchOptimizationPage")),
    meta: {
      title: "AI Search Optimization",
      description: "AI Search Optimization Framework with scoring and prioritization"
    }
  },
  {
    path: "/job-management",
    element: lazy(() => import("@/pages/JobManagementPage")),
    meta: {
      title: "Job Management",
      description: "Manage background jobs, services, and schedules"
    }
  },
  {
    path: "/pm-prompts",
    element: lazy(() => import("@/pages/PMPromptsPage")),
    meta: {
      title: "Prompts Settings",
      description: "Configure custom prompts and settings for performance marketing campaigns"
    }
  },
  {
    path: "/test-saio-dashboard",
    element: lazy(() => import("@/pages/TestSaioDashboard")),
    meta: {
      title: "Test SAIO Dashboard",
      description: "Debug version of SAIO dashboard for testing reload issues"
    }
  },
  {
    path: "/saio-settings",
    element: lazy(() => import("@/pages/SaioSettingsPage")),
    meta: {
      title: "SAIO Settings",
      description: "Configure Search AI Optimization prompts and settings"
    }
  },
  {
    path: "/saio-data-exploration-tool",
    element: lazy(() => import("@/pages/SaioDataExplorationPage")),
    meta: {
      title: "SAIO Data Exploration Tool",
      description: "Explore and analyze SAIO data with AI assistance"
    }
  }
];
